/*doc

 Renders the list of authors the current user follows.
 Each followed author's widget is rendered individually in
 AskTheAuthorCommunityQuestionAnswerContainer

 Loads three authors at a time, displays a "Load more authors you follow"
 link conditionally if there are more authors in the store
 that have not been displayed

 */

import GrComponentFactory from "../../gr_component_factory";
import AskTheAuthorCommunityQuestionAnswerContainer from "./community_question_answer_container";
import AskTheAuthorFollowedAuthorsStore from "../../../react_stores/ask_the_author_followed_authors_store";
import AskTheAuthorFollowedAuthorsActions from "../../../react_actions/ask_the_author/followed_authors_actions";
import Reflux from "reflux";
import GrPropTypes from "../../shared/gr_prop_types";
import { get } from "lodash";

export default GrComponentFactory.createClass({
  mixins: [Reflux.connect(AskTheAuthorFollowedAuthorsStore, "askTheAuthorFollowedAuthorsStore")],
  displayName: "AskTheAuthorFollowedAuthorsContainer",

  propTypes: {
    currentUser: GrPropTypes.user().isRequired,
  },

  loadMoreFollowedAuthors(){
    AskTheAuthorFollowedAuthorsActions.loadMoreFollowedAuthors();
  },
  // if we have no more authors to show, do not display bottom border
  getContainerClassName(currentAuthor, lastAuthor, showLink){
    if(showLink<1 && lastAuthor=== JSON.stringify(currentAuthor)){
      return "u-marginTopSmall u-marginBottomSmall";
    }
    return "u-marginTopSmall u-marginBottomSmall u-bottomGrayBorder";
  },
  render() {
    const state = this.state.askTheAuthorFollowedAuthorsStore;
    const numOfAuthorsToDisplay = state.authors ? state.authors.length : 0;
    const lastAuthor = numOfAuthorsToDisplay > 0 ? JSON.stringify(state.authors[numOfAuthorsToDisplay-1])
      : null;
    const totalNumOfAuthors = state.total;
    const showLink = totalNumOfAuthors-numOfAuthorsToDisplay;
    let classNameLine, commentData, likeData;
    const currentUser = this.props.currentUser;
    return (
      <div className="communityContainer">
        {
          state.authors.map((auth) => {
            classNameLine = this.getContainerClassName(auth, lastAuthor, showLink);
            commentData = get(auth, "social.comment");
            likeData = get(auth, "social.like");
            return <div key={auth.profileUrl}>
              <div className={classNameLine}>
                <AskTheAuthorCommunityQuestionAnswerContainer
                  authorUser={{
                    viewableName: auth.name,
                    profileUrl: auth.profileUrl,
                    profileImage: auth.profileImage,
                  }}
                  currentUser={currentUser}
                  authorTagline={auth.authorTagline}
                  questionURL={auth.questionURL}
                  answerURL={auth.answerURL}
                  answersCountText={auth.answersCountText}
                  ATAenabled={auth.ATAenabled}
                  communityQuestionText={auth.recentQuestionText}
                  communityAnswerText={{
                    html: auth.recentAnswerTruncatedHtml.html,
                    fullContentText: auth.recentAnswerTruncatedHtml.answerText,
                    truncated: auth.recentAnswerTruncatedHtml.truncated,
                  }}
                  questionSpoiler={auth.recentQuestionSpoiler}
                  answerSpoiler={auth.recentAnswerSpoiler}
                  flagForAbuseUrl={auth.flagForAbuseUrl}
                  like={{
                    key: likeData.key,
                    label: likeData.label,
                    isLikeable: likeData.isLikeable,
                  }}
                  comment={{
                    canComment: commentData.canComment,
                    commentable: commentData.commentable,
                    subjectKey: commentData.subjectKey,
                    subject: {
                      type: commentData.subject.type,
                      id: commentData.subject.id,
                    },
                    subjectUrl: commentData.subjectUrl,
                  }}
                /></div>
            </div>;
          })
        }
        {showLink>0 ? <button className="gr-buttonAsLink askTheAuthorCommunityQuestionAnswerContainer__followLink"
                              onClick={this.loadMoreFollowedAuthors}> More Authors You Follow… </button> : null}
      </div>
    );
  },
});
